import { CustomPIXIComponent } from 'react-pixi-fiber'
import { Container } from 'pixi.js'
import { Spine } from 'pixi-spine'
import SymbolScales from "game/components/reels/symbols/SymbolScales"
import { Loader } from "pixi.js"
const { resources } = Loader.shared

const { floor } = Math

const SCALE = 1.2
const HIGH_SYMBOLS = ["H1", "H2", "H3"]

//CUSTOM REACT-PIXI CLASS
export default CustomPIXIComponent({

    customDisplayObject(props) {
        const { spine, symbol, x, y, width, height, paused } = props
        const spineData = resources[spine].spineData
        const timeScale = !paused ? 1 : 0

        const container = new Container()

        const sprite = new Spine(spineData)
        sprite.state.setAnimation(0, symbol, true)
        sprite.state.timeScale = timeScale

        container.addChild(sprite)

        if (HIGH_SYMBOLS.indexOf(symbol) >= 0) {
            const starSpineData = resources["winning-symbols-star"].spineData
            const star = new Spine(starSpineData)
            star.state.setAnimation(0, `${symbol}_star`, true)
            star.state.timeScale = timeScale
            container.addChildAt(star, 0)

            const glowSpineData = resources["winning-symbols-glow"].spineData
            const glow = new Spine(glowSpineData)
            glow.state.setAnimation(0, `${symbol}_glow`, true)
            glow.state.timeScale = timeScale
            container.addChild(glow)
        }

        return container
    },

    customApplyProps(displayObject, oldProps, newProps) {
        const { x, y, width, height, paused, symbol } = newProps
        const timeScale = !paused ? 1 : 0

        displayObject.children.forEach((child) => {
            child.state.timeScale = timeScale
        })

        if (width !== oldProps.width || height !== oldProps.height) {
            displayObject.width = width * (SymbolScales[symbol] || 1) * SCALE
            displayObject.scale.y = displayObject.scale.x
        }

        displayObject.x = floor((x * width) + (width * 0.5))
        displayObject.y = floor((y * height) + (height * 0.5))
    }
}, 'WinningSymbol')

